import gasnet_white from '../images/gasnet_white.svg';
import gasnet_logo_white from '../images/GasNet_logo_white.png';
import gasnet_logo_green from '../images/GasNet_logo_zelena.png';
import article_icon from '../images/article-icon.svg';
import video_icon from '../images/video-icon.svg';
import personal_questionnaire_icon from '../images/personal-questionnaire-icon.svg';
import medical_exam_icon from '../images/medical-exam-icon.svg';
import important_document_icon from '../images/important-document-icon.svg';
import favicon from '../images/logo.png';
import innogy_rocket from '../images/innogy_rocket.svg';

import is_digitalization from '../images/innogy_style/digitalization.svg';
import is_people from '../images/innogy_style/people.svg';
import is_personal_growth from '../images/innogy_style/personal-growth.svg';
import is_values from '../images/innogy_style/values.svg';
import is_work_environment from '../images/innogy_style/work-environment.svg';
import is_work_style from '../images/innogy_style/work-style.svg';

const images = {
  gasnet_logo_green,
  gasnet_logo_white,
  gasnet_white,
  innogy_rocket,
  content_units: {
    article_icon,
    video_icon,
    personal_questionnaire_icon,
    medical_exam_icon,
    important_document_icon,
  },
  favicon,
  innogy_style: {
    is_digitalization,
    is_people,
    is_personal_growth,
    is_values,
    is_work_environment,
    is_work_style
  }
};

export default images;
